import React from 'react';

export const BoardMapRegionsLayer = ({
  regions,
  selectedRegionId,
  selectedRegionIds = [],
  onRegionClick,
  onRegionDoubleClick,
  onRegionPointerDown,
  onRegionPointPointerDown,
  canvasWidth,
  canvasHeight,
  regionDraftPoints = [],
  regionDraftHoverPoint = null,
  offsetX = 0,
  offsetY = 0,
  getRegionNodeId,
}) => (
  <svg
    className='absolute inset-0'
    width={canvasWidth}
    height={canvasHeight}
    viewBox={`0 0 ${canvasWidth} ${canvasHeight}`}
    preserveAspectRatio='none'
    style={{ zIndex: 10, pointerEvents: 'none' }}
  >
    <g transform={`translate(${offsetX} ${offsetY})`}>
      {regions.map(region => {
      const points = Array.isArray(region?.points)
        ? region.points.map(point => `${point.x},${point.y}`).join(' ')
        : '';
      const isSelected =
        selectedRegionId === region.id || selectedRegionIds.includes(region.id);
      if (!points) {
        return null;
      }
      return (
        <g key={region.id}>
          <polygon
            data-map-region-root='true'
            data-map-node-id={getRegionNodeId?.(region.id) || undefined}
            points={points}
            fill={`rgb(var(--${region?.fill || 'secondary'}))`}
            fillOpacity={Number.isFinite(region?.fillOpacity) ? region.fillOpacity : 0.2}
            stroke={`rgb(var(--${isSelected ? 'secondary' : region?.stroke || 'secondary'}))`}
            strokeWidth={
              isSelected
                ? Math.max(3, Number(region?.strokeWidth) || 0)
                : Number(region?.strokeWidth) || 0
            }
            strokeDasharray={region?.strokeDasharray || undefined}
            pointerEvents='all'
            onPointerDown={event => {
              event.stopPropagation();
              onRegionPointerDown?.(event, region.id);
            }}
            onClick={event => {
              event.stopPropagation();
              onRegionClick?.(region, event);
            }}
            onDoubleClick={event => {
              event.stopPropagation();
              onRegionDoubleClick?.(region, event);
            }}
          />
          {selectedRegionId === region.id &&
            Array.isArray(region?.points) &&
            region.points.map((point, pointIndex) => (
              <circle
                key={`${region.id}-point-${pointIndex}`}
                cx={point.x}
                cy={point.y}
                r={5}
                fill='rgb(var(--secondary))'
                stroke='rgb(var(--main))'
                strokeWidth='1'
                pointerEvents='all'
                onPointerDown={event => {
                  event.stopPropagation();
                  onRegionPointPointerDown?.(event, region.id, pointIndex);
                }}
              />
            ))}
        </g>
      );
      })}
      {Array.isArray(regionDraftPoints) && regionDraftPoints.length > 0 && (
      <>
        <polyline
          points={[
            ...regionDraftPoints.map(point => `${point.x},${point.y}`),
            regionDraftHoverPoint
              ? `${regionDraftHoverPoint.x},${regionDraftHoverPoint.y}`
              : null,
          ]
            .filter(Boolean)
            .join(' ')}
          fill='none'
          stroke='rgb(var(--secondary))'
          strokeWidth='2'
          strokeDasharray='4 3'
          strokeOpacity='0.95'
          pointerEvents='none'
        />
        {regionDraftPoints.length >= 3 && (
          <polygon
            points={regionDraftPoints.map(point => `${point.x},${point.y}`).join(' ')}
            fill='rgb(var(--secondary))'
            fillOpacity='0.08'
            stroke='rgb(var(--secondary))'
            strokeWidth='2'
            strokeDasharray='4 3'
            strokeOpacity='0.95'
            pointerEvents='none'
          />
        )}
        {regionDraftPoints.map((point, index) => (
          <circle
            key={`draft-point-${index}`}
            cx={point.x}
            cy={point.y}
            r={index === 0 ? 5 : 4}
            fill='rgb(var(--secondary))'
            fillOpacity={index === 0 ? 0.95 : 0.75}
            pointerEvents='none'
          />
        ))}
      </>
      )}
    </g>
  </svg>
);
